import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TravelService } from '../../api/services';
import { AuthService } from '../services/auth.service';
import { catchError, map, of } from 'rxjs';

export const travelAccessGuard: CanActivateFn = (route, state) => {
  const travelService = inject(TravelService);
  const authService = inject(AuthService);
  const router = inject(Router);
  const myId = authService.user.value?.id;
  const travelId = route.params['travel_id'];
  if (!myId) {
    // se non sono loggato prima mi porta al login poi all url della pagina da cui provenivo
    return router.createUrlTree(['/login'], {
      queryParams: { back_to_url: state.url },
    });
  }
  return travelService.travelControllerGetTravel({ id: travelId }).pipe(
    map((res) => {
      const travel = res.data;

      return travel.related_user.id === myId ||
        travel.assignment?.target_user.id === myId
        ? true
        : router.createUrlTree(['/']);
    }),
  );
};
